/**
 * Created by kb on 2017/11/21.
 */
import  { menuPage } from  '@/commonJs/commonconf'
import NProgress from 'nprogress' // Progress 进度条
import 'nprogress/nprogress.css'// Progress 进度条样式
import {mappingMenuPage} from './commonJs/objExtend/permission'
import store from './store'
import router from './router'


//白名单路由
let Whitelist=['/','/login','/news','/newsInfo','/about','/about2','/about3','/mima','/zhuce','/static/utf8-jsp/jsp/controller.jsp','/ssoLogin']

//判断当前即将跳转的路由路径是否是白名单
function  NotPermission(path) {
  return Whitelist.filter(value => {
      return new RegExp("^" + value + "{1}([\/\?]{1}[^]*)?$", "i").test(path)
    }).length > 0
}

//路由权限校验
router.beforeEach((to, from, next) => {

  if (to.path == "/desk" && from.path == "/") {
    var storage = window.sessionStorage;
    for (var i = 0, len = storage.length; i < len; i++) {
      var key = storage.key(i);
      if (key.indexOf("/") == 0) {
        storage.setItem(key, 0);
      }
    }
  }


  NProgress.start() // 开启Progress
  store.commit('system/SET_LODING', true);

  //判断当前跳转路径是否是白名单
  if (NotPermission(to.path)) {
    next()
  } else {
    if (!store.getters.token || !store.getters.user) {
      next({path: '/login'})
    } else {
      //判断是否拉取左菜单用户权限信息'
      if (store.getters.roles.length === 0) {
        store.dispatch("system/GetLetMenuRoles").then(() => {
          store.dispatch("system/GeneraRouter", store.getters.roles).then((Routers) => {
            router.addRoutes(Routers);
            next({...to}); //hack 方法  保证addroutes已完成
          })
        }).catch((e) => {
          if (!store.getters.token || !store.getters.user) {
            store.dispatch('system/LoginOut').then(() => {
              next({path: '/'})
            })
          } else {
            next();
          }
        })
      } else {
           mappingMenuPage(to.path);//映射界面编码
          //查找界面对应的权限
          store.dispatch('system/GetBtnListByPageCode',to.path).then(() => {
            next();
          }).catch((e) => {
            next({path: e.message});
          })
      }
    }
  }
});


router.afterEach((to, from) => {
    setTimeout(function () {
      NProgress.done() // 结束Progress
      store.commit('system/SET_LODING', false);
    }, 350)
})



// WEBPACK FOOTER //
// ./src/permission.js